import React, { useEffect, useState } from "react";
import { Container, Card } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import userPhoto from "../../../images/user.png";
import { toast } from "react-toastify";
import { MdAddPhotoAlternate, MdDelete, MdEdit } from "react-icons/md";
import { IconButton } from "@mui/material";
import { Button, Input, Spin, Modal, Pagination, Radio } from "antd";
import CountUp from "react-countup";
import { Message, ViewInput } from "../../../GlobalStyles";
import { ExclamationCircleFilled } from "@ant-design/icons";

const { confirm } = Modal;

export default function Admins() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [Admins, setAdmins] = useState([]);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [adminsTotal, setAdminsTotal] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [photo, setPhoto] = useState("");
  const [page, setPage] = useState(0);
  const [accessGranted, setAccessGranted] = useState([]);
  const [password, setPassword] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    listAdmins();
  }, [page, filterSearch]);

  async function listAdmins() {
    setLoading(true);
    await api
      .get(`/admins?page=${page}&filter=${filterSearch}`)
      .then((response) => {
        setAdmins(response.data.admins);
        setAdminsTotal(response.data.adminsTotal);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function createAndEditAdmin() {
    setIsLoadingModal(true);
    if (id) {
      if (!name || !email) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("password", password);
        data.append("email", email.toLowerCase().replace(/ /g, ""));
        data.append("access_granted", accessGranted);
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .put(`/admin/${id}`, data)
          .then(async (ok) => {
            toast.success("Administrador editado com sucesso");
            listAdmins();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    } else {
      if (!name || !email || !password) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("password", password);
        data.append("email", email.toLowerCase().replace(/ /g, ""));
        data.append("access_granted", accessGranted);
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .post(`/admin`, data)
          .then(async (ok) => {
            toast.success("Administrador criado com sucesso");
            listAdmins();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteAdmin(id) {
    await api
      .delete(`/admin/${id}`)
      .then(() => {
        toast.success("Administrador excluido com sucesso");
        listAdmins();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Administradores</h1>

      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={adminsTotal} />
          </Card>
          <div className="filter">
            <ViewInput style={{ width: 300 }}>
              <p>Pesquisar</p>
              <Input.Search
                value={filter}
                onChange={(text) => {
                  setFilter(text.target.value);
                }}
                placeholder="pesquisar"
                onSearch={(text) => {
                  setFilterSearch(text);
                  if (page) {
                    setPage(0);
                  }
                }}
                allowClear
                onClear={() => {
                  setFilterSearch("");
                  if (page) {
                    setPage(0);
                  }
                  setFilter("");
                }}
                enterButton
              />
            </ViewInput>
            <Button
              type="primary"
              style={{
                marginTop: 17,
                marginLeft: 50,
                borderRadius: 50,
              }}
              onClick={() => {
                setId("");
                setName("");
                setEmail("");
                setPassword("");
                setPhoto("");
                setAccessGranted("");
                setVisibleModal(true);
              }}
            >
              Novo Administrador
            </Button>
          </div>
          {Admins.length == 0 && (
            <Message>Nenhum administrador encontrado</Message>
          )}
          <div className="orders">
            {Admins.map((item) => {
              return (
                <div className="order">
                  <img src={item.photo ? item.photo_url : userPhoto} />
                  <div className="infos">
                    <p>{item.name}</p>
                    <p style={{ color: "#0008", marginTop: 5 }}>{item.email}</p>
                    <p style={{ color: "#000a", marginTop: 5 }}>
                      Acessos:{" "}
                      {item.access_granted
                        ? item.access_granted.replaceAll(",", ", ").slice(0, -2)
                        : "Total"}
                    </p>
                  </div>
                  <div className="actions">
                    <Button
                      type="primary"
                      className="warning-button"
                      onClick={() => {
                        setId(item.id);
                        setName(item.name);
                        setEmail(item.email);
                        setPhoto({ photo_url: item.photo_url });
                        setPassword("");
                        setAccessGranted(item.access_granted);
                        setVisibleModal(true);
                      }}
                    >
                      <MdEdit color="#FFF" size={20} />
                      Editar
                    </Button>
                    <Button
                      type="primary"
                      className="delete-button"
                      onClick={() => {
                        confirm({
                          okText: "Confirmar",
                          title: `Deseja excluir o Administrador ${item.name}?`,
                          icon: <ExclamationCircleFilled />,
                          content: `O administrador será excluido e perderá o acesso ao sistema`,
                          onOk() {
                            deleteAdmin(item.id);
                          },
                          onCancel() {},
                          cancelText: "Cancelar",
                        });
                      }}
                    >
                      <MdDelete color="#FFF" size={20} />
                      Exluir
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>

          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={adminsTotal}
          />
        </>
      )}

      <Modal
        title="Administrador"
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={id ? "EDITAR ADMIN" : "CADASTRAR ADMIN"}
        cancelText="FECHAR"
        onOk={() => {
          createAndEditAdmin();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              marginTop: 0,
              width: 260,
              height: 160,
              borderRadius: 10,
              marginBottom: 25,
              marginBottom: 20,
              justifyContent: "center",
            }}
          >
            <img
              style={{
                width: 160,
                marginLeft: 50,
                height: 160,
                borderRadius: 10,
                background: "#fff",
              }}
              src={photo.photo_url ? photo.photo_url : userPhoto}
            />
            <IconButton style={{ width: 50, height: 50, bottom: 15 }}>
              <label
                for="avatar"
                style={{
                  display: "flex",
                  width: 50,
                  height: 50,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <MdAddPhotoAlternate color="#000" />
                <input
                  id="avatar"
                  style={{ display: "none" }}
                  type="file"
                  accept="image/"
                  onChange={(file) => {
                    let photo = file.target.files[0];
                    photo.photo_url = URL.createObjectURL(file.target.files[0]);
                    setPhoto(photo);
                  }}
                />
              </label>
            </IconButton>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <ViewInput>
              <p>Nome*</p>
              <Input
                placeholder="nome"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Email*</p>
              <Input
                placeholder="suario@gmail.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>{id ? "Nova Senha" : "Senha*"}</p>
              <Input
                placeholder={"****"}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </ViewInput>
            {id != "58e368a8-f71c-40da-a5f6-bcc31a7386ad" && (
              <ViewInput
                style={{
                  justifyContent: "flex-start",
                }}
              >
                <p>Acesso ao Sistema</p>
                <Radio
                  checked={!accessGranted}
                  onClick={() => {
                    setAccessGranted("");
                  }}
                >
                  Acesso Total
                </Radio>
                {[
                  "Usuários",
                  "Serviços",
                  "Pagamentos",
                  "OSs",
                  "Depósitos",
                  "Chamados",
                  "Banners",
                  "Cursos",
                  "Credenciados",
                  "Contratos",
                  "Leads",
                  "Formulários",
                  "Comunicados",
                  "Cupom de Desconto",
                ].map((item) => {
                  return (
                    <Radio
                      checked={accessGranted.includes(item)}
                      onClick={() => {
                        if (accessGranted.includes(item)) {
                          setAccessGranted(
                            accessGranted.replace(item + ",", ""),
                          );
                        } else {
                          setAccessGranted(accessGranted + item + ",");
                        }
                      }}
                    >
                      {item}
                    </Radio>
                  );
                })}
              </ViewInput>
            )}
          </div>
        </div>
      </Modal>
    </Container>
  );
}
